import {TreatmentPlanningProcedurePseudoModel} from '../../modules/treatment-planning/models/treatment-planning-procedure-pseudo.model';

export class CreatePatientCaseModel {
  PatientCaseId: string = null;
  ParentCaseId: string = null;
  patientID: string;
  LOCID: number;
  Description: string;
  ReferringDoctorContactID: string;
  ReferringDoctorID: string;
  CaseProcedureId: string;
  TreatmentPlanningID: string;
  TreatmentPlanningProcedures: TreatmentPlanningProcedurePseudoModel[];
  enumCaseStatusID: string;
}
